import screen from './rbata.screen';

const accordion = {
    selector: '.js-accordion-scroll',
    bindHandler() {
        $(this.selector).on('shown.bs.collapse', (evt) => {
            const $target = $(evt.target);
            if ($target.closest('.modal').length) {
                if (!screen.isOnScreen($target, '.cs__accordion-wrapper')) {
                    $target.prev()[0].scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
                }
            } else {
                if (!screen.isOnScreen($target)) {
                    $target.prev()[0].scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});
                }
            }
        })
    },
    showCollapse() {
        const hash = location.hash;

        if (hash !== null && hash !== '') {
            $(hash.split('&')[0]).next('.collapse').collapse('show');
        }
    }
};

$(() => {
    accordion.bindHandler();
    if ($('#cs-page').length) {
        accordion.showCollapse();
    }
});

export default accordion;
